const moment = require("moment");
module.exports = {
  clock: (dateObj) => {
    let date = new Date();
    if (dateObj !== null && dateObj !== undefined) {
      date = new Date(dateObj);
    }
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    const time = hours + ":" + minutes + " " + ampm;
    return time;
  },
  clockFullLength: (dateObj) => {
    let date = new Date();
    if (dateObj !== null && dateObj !== undefined) {
      date = new Date(dateObj);
    }
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;
    const time = hours + ":" + minutes + ":" + seconds + " " + ampm;
    return time;
  },
  timeStamp: (dateObj) => {
    let date = new Date();
    if (dateObj !== null && dateObj !== undefined) {
      date = new Date(dateObj);
    }
    return date.toISOString().split("T")[0] + " " + date.toTimeString().split(" ")[0];
  },
  timeValidator: (sTime, eTime, cTime) => {
    const startDate = sTime ? moment(sTime).format("DD-MM-YYYY HH:mm:ss") : moment("2000-01-01").format("DD-MM-YYYY HH:mm:ss");
    const endDate = eTime ? moment(eTime).format("DD-MM-YYYY HH:mm:ss") : moment("2050-01-01").format("DD-MM-YYYY HH:mm:ss");
    const curDate = cTime ? moment(cTime).format("DD-MM-YYYY HH:mm:ss") : moment(new Date()).format("DD-MM-YYYY HH:mm:ss");
    return curDate >= startDate && curDate <= endDate;
  },

  dateValidator: (sDate, eDate, cDate) => {
    const startDate = sDate ? moment(sDate) : moment("2000-01-01");
    const endDate = eDate ? moment(eDate) : moment();
    const currentDate = cDate ? moment(cDate) : moment();
    return currentDate.isSameOrAfter(startDate) && currentDate.isSameOrBefore(endDate);
  },

  currentDay: () => {
    const date = new Date();
    const days = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
    return days[date.getDay()];
  },
};
